"use strict";
/*
 * Created on 20/08/2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceArchitectureDTO_1 = require("../model/PriceArchitectureDTO");

var PriceArchitectureDTOConverter_1 = require("./PriceArchitectureDTOConverter");
/**
 * Implementation of PriceArchitectureDTOConverter
 *
 * @author JMr
 * @author Zdeněk Straka
 */


var PriceArchitectureDTOConverterImpl =
/*#__PURE__*/
function (_PriceArchitectureDTO) {
  _inherits(PriceArchitectureDTOConverterImpl, _PriceArchitectureDTO);

  function PriceArchitectureDTOConverterImpl() {
    _classCallCheck(this, PriceArchitectureDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceArchitectureDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PriceArchitectureDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceArchitectureDTO_1.PriceArchitectureDTO(PriceArchitectureDTO_1.PriceArchitectureDTO.schema.id.valueOf(conversions.documentToClassId(source)), PriceArchitectureDTO_1.PriceArchitectureDTO.schema.categoryId.valueOf(conversions.documentToClassId(source)), PriceArchitectureDTO_1.PriceArchitectureDTO.schema.newWithRecommended.valueOfField(source), PriceArchitectureDTO_1.PriceArchitectureDTO.schema.newWithoutRecommended.valueOfField(source), PriceArchitectureDTO_1.PriceArchitectureDTO.schema.totalProducts.valueOfField(source), PriceArchitectureDTO_1.PriceArchitectureDTO.schema.notAssignedProducts.valueOfField(source), PriceArchitectureDTO_1.PriceArchitectureDTO.schema.numberOfFamilies.valueOfField(source), // not used
      source.level, // TODO ZSt review this ???
      source.parentId, // TODO ZSt review this ???
      source.childrenCount);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        categoryId: source.categoryId,
        newWithRecommended: source.newWithRecommended,
        newWithoutRecommended: source.newWithoutRecommended,
        totalProducts: source.totalProducts,
        notAssignedProducts: source.notAssignedProducts,
        numberOfFamilies: source.numberOfFamilies,
        level: source.level,
        parentId: source.parentId,
        childrenCount: source.childrenCount
      });
      return result;
    }
  }]);

  return PriceArchitectureDTOConverterImpl;
}(PriceArchitectureDTOConverter_1.PriceArchitectureDTOConverter);

exports.PriceArchitectureDTOConverterImpl = PriceArchitectureDTOConverterImpl;